import type { HelpContentMap, HelpContentOverride, HelpKey } from './types';
import { defaultHelpContent } from './default';
import { hypeappHelpContent } from './hypeapp';

export type { HelpKey, HelpContentMap, HelpContentOverride } from './types';

/**
 * ブランド別の上書きマップ。新しい OEM を追加したらここにキーを登録する。
 * キーは brands/ ディレクトリの `id`（= VITE_BRAND の値）と合わせる。
 */
const overrides: Record<string, HelpContentOverride> = {
  hypeapp: hypeappHelpContent,
};

/**
 * 現在のブランドに応じたヘルプ文言マップを返す。
 * 上書きが存在しないキーはデフォルト文言にフォールバック。
 */
export function getHelpContent(): HelpContentMap {
  const brandId = import.meta.env.VITE_BRAND || 'default';
  const override = overrides[brandId] ?? {};
  return { ...defaultHelpContent, ...override };
}

/** モジュールロード時に確定する、現在ブランド向けのヘルプ文言マップ */
export const helpContent = getHelpContent();

export type { HelpKey as HelpContentKey };
